// # helpers
import { angularComponent } from './reactInAngular';
// # components
import { SelectCategories } from '@/components/categories';
import { ManagePaymentCards } from '@/components/payment';
// # scenes
import AdminRolesScene from '@/components/scenes/admin/roles';
import { AdminPlansScene } from '@/components/scenes/admin/plans';
import { AccountSubscriptionScene } from '@/components/scenes/account';
// # content
import { ContentEditor } from '@/components/ContentEditor';
// # feedback
import { Message, Spinner } from '@/components/feedback';
import { Select } from '@/components/Select';
// # forms
import { CategoryTypeForm } from '@/components/forms';
// # modal
import { Frame as ModalFrame } from '@/components/modal';
// # users
import { UserAttributes } from '@/components/users';

import EventCalendar from '@/components/events/EventCalendar';

// register our react components with angular
angular.module('app')
    .component('eventCalendar', angularComponent(EventCalendar, ['events', 'siteSettings']))

    // categories
    .component('selectCategories', angularComponent(SelectCategories, ['categoryTypes', 'onChange', 'selectedCategoryIds']))
    // content
    .component('contentEditor', angularComponent(ContentEditor, ['disabled', 'value', 'onChange', 'toolbarGroups']))
    // feedback
    .component('message', angularComponent(Message, ['children', 'title', 'theme']))
    .component('spinner', angularComponent(Spinner))
    // forms
    .component('categoryTypeForm', angularComponent(CategoryTypeForm, ['categorizables', 'categoryType', 'isBusy', 'onSave']))
    // input
    .component('reactSelect', angularComponent(Select, ['items', 'onSelect', 'placeholder', 'value']))
    // scenes
    .component('adminRolesScene', angularComponent(AdminRolesScene))
    .component('adminPlansScene', angularComponent(AdminPlansScene))
    .component('accountSubscriptionScene', angularComponent(AccountSubscriptionScene))
    // payment
    .component('managePaymentCards', angularComponent(ManagePaymentCards))
    // modal
    .component('modalFrame', angularComponent(ModalFrame, ['title', 'onClose']))
    // users
    .component('userAttributes', angularComponent(UserAttributes, ['attributes', 'onChange', 'values']))
;
